import { render, staticRenderFns } from "./MerchandiseViewBody.vue?vue&type=template&id=4043449a&scoped=true&"
import script from "./MerchandiseViewBody.vue?vue&type=script&lang=js&"
export * from "./MerchandiseViewBody.vue?vue&type=script&lang=js&"
import style0 from "./MerchandiseViewBody.vue?vue&type=style&index=0&id=4043449a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4043449a",
  null
  
)

component.options.__file = "MerchandiseViewBody.vue"
export default component.exports